<template>
	<div>
		<div class="card poppins-medium text-white rounded-lg mt-3" v-if="carousel.length > 0">
			<div class="card-body">
				<div id="carouselControls" class="carousel slide" data-ride="carousel">
					<ol class="carousel-indicators">
						<li
						v-for="(i, idx) in carousel"
						data-target="#carouselControls"
						:data-slide-to="idx"
						:class="{active: idx === 0}"
						:key="idx"
						></li>
					</ol>
					<div class="carousel-inner">
						<div class="carousel-item" v-for="(i, idx) in carousel" :key="idx" :class="{active: idx === 0}">
							<img :src="i.imagen" class="d-block w-100" :alt="i.titulo">
							<div class="carousel-caption d-none d-md-block" v-if="i.titulo !== null">
								<h5>{{ i.titulo }}</h5>
								<p v-if="i.subtitulo !== null">{{ i.subtitulo }}</p>
							</div>
						</div>
					</div>
					<button class="carousel-control-prev" type="button" data-target="#carouselControls" data-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="sr-only">Previous</span>
					</button>
					<button class="carousel-control-next" type="button" data-target="#carouselControls" data-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="sr-only">Next</span>
					</button>
				</div>
			</div>
		</div>
		<div class="card bg-principal poppins-medium text-white rounded-lg mt-3" v-else>
			<div class="card-body">
				<h3 class="color-white">
					Tus envíos y cobros de forma sencilla.
				</h3>
				<p class="color-white">
					Sabemos que el control de tus envíos y cobros es muy importante, por ello C807Xpres te brinda esta herramienta pues nuestro compromiso es ayudarte a que tu negocio siga creciendo. 
				</p>
			</div>
		</div>
		
		<div class="card poppins-medium mt-3">
			<div class="card-body">
				<h5  class="card-title">Total de envíos del mes : {{ totalEnvios }}</h5 >
				</div>
			</div>
			
			<div class="card-group">
				<div class="card">
					<div class="row no-gutters">
						<div class="col-8">
							<div class="card-body">
								<h5 class="card-title">Envíos entregados</h5>
								<h1 class="card-text">{{ entregas }}</h1>
							</div>
						</div>
						<div class="col-4 p-2">
							<img src="@/assets/img/iconos/graphics.png" alt="graphics" class="img-fluid">
						</div>
					</div>
				</div>
				<div class="card">
					<div class="row no-gutters">
						<div class="col-8">
							<div class="card-body">
								<h5 class="card-title">Envíos en ruta</h5>
								<h1 class="card-text">{{ enRuta.length }}</h1>
							</div>
						</div>
						<div class="col-4 p-2">
							<img src="@/assets/img/iconos/graphics.png" alt="graphics" class="img-fluid">
						</div>
					</div>
				</div>
				<div class="card">
					<div class="row no-gutters">
						<div class="col-8">
							<div class="card-body">
								<h5 class="card-title">Problemas en gestión</h5>
								<h1 class="card-text">{{ problemas }}</h1>
							</div>
						</div>
						<div class="col-4 p-2">
							<img src="@/assets/img/iconos/graphics2.png" alt="graphics" class="img-fluid">
						</div>
					</div>
				</div>
			</div>
			
			<div class="card-deck mt-3">
				<div class="card bg-principal poppins-medium text-white rounded">
					<div class="card-body">
						<h5 class="card-title" style="font-size: 2rem;">Reintegro de CCE</h5>
						<div class="card-text text-center">
							<div class="row">
								<div class="col" style="font-size: 3rem;">Pagado</div>
								<div class="col" style="font-size: 3.5rem;">{{ formatoNumero(reintegroCce) }}</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="card bg-principal poppins-medium rounded" style="color: #C4D600">
					<div class="row no-gutters">
						<div class="col-md-8">
							<div class="card-body text-center">
								<h5 class="card-title" style="font-size: 2rem;">Saldo disponible</h5>
								<h1 class="card-text" style="font-size: 3.5rem; font-weight: bold;">{{ formatoNumero(saldo) }}</h1>
							</div>
						</div>
						<div class="col-md-4 p-2 text-center">
							<img src="@/assets/img/resource/wallet.png" alt="graphics" class="img-fluid">
						</div>
					</div>
				</div>
			</div>
			
			<div class="card poppins-medium mt-3">
				<div class="card-header">
					<a
					href="#collapseOne"
					class="color-verde"
					data-toggle="collapse"
					aria-expanded="false"
					aria-controls="collapseOne"
					>Mis envíos en ruta</a>
				</div>
				<div class="table-responsive collapse" id="collapseOne" aria-labelledby="headingOne">
					<table class="table table-sm table_style">
						<thead class="thead-light">
							<tr>
								<th scope="col"># Guia</th>
								<th scope="col">Creación</th>
								<th scope="col">Observacion</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(i, idx) in enRuta" :key="idx">
								<th scope="row">
									{{ i.numero }}
								</th>
								<td>{{ i.creacion }}</td>
								<td>{{ i.contenido }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</template>
	
	<script>
	import axios from 'axios'
	export default {
		name: 'GuiaResumen',
		data: () => ({
			entregas: 0,
			enRuta: [],
			problemas: 0,
			saldo: 0,
			reintegroCce: 0,
			carousel: []
		}),
		created() {
			this.getDatos()
		},
		methods: {
			getDatos() {
				axios.get(this.UrlBase+'/reporte/resumen')
				.then(r => {
					this.entregas = r.data.entregas.total
					this.enRuta = r.data.en_ruta
					this.problemas = r.data.problemas.total
					this.saldo = parseFloat(r.data.saldo).toFixed(2)
					this.reintegroCce = r.data.cce.total ? parseFloat(r.data.cce.total).toFixed(2) : 0
					this.carousel = r.data.carousel
				})
			},
			formatoNumero(num) {
				return parseFloat(num).toLocaleString()
			}
		},
		computed: {
			totalEnvios() {
				return parseInt(this.entregas) + parseInt(this.enRuta.length) + parseInt(this.problemas)
			}
		}
	}
</script>